import * as angular from 'angular';

import { ReportTypes } from '@mode/shared/contract-common';

/**
 * Parameters info and tooltip presentation component.
 *
 */
class ParametersInfoController implements angular.IController {
  // bindings
  parameters: ReportTypes.ReportRunFormField[];
  reportUrl: string;

  constructor() {}
}

export const ParametersInfoComponent: angular.IComponentOptions = {
  bindings: {
    reportUrl: '<',
    parameters: '<',
  },
  controller: ParametersInfoController,
  controllerAs: 'ctrl',
  template: `
  <div class="parameters-panel">
    <div class="parameters-panel-info">
      <h4 class="parameters-header-title font-note">
        PARAMETERS
      </h4>
      <div class="parameters-info-list">
        <dl>
          <div ng-repeat="parameter in ctrl.parameters">
            <parameters-info-field parameter="parameter" class="parameter">
            </parameters-info-field>
          </div>
        </dl>
      </div>
    </div>
    <a
      class="change-report-cta"
      ng-href="{{ ctrl.reportUrl }}"
      target="_blank"
    >
      <svg-icon class="icon" type="'return-arrow-icon'"></svg-icon> Change in Report ({{ctrl.parameters.length}} total)
    </a>
  </div>
  `,
};
